import { render, staticRenderFns } from "./401.vue?vue&type=template&id=2c55b214&scoped=true"
var script = {}
import style0 from "./401.vue?vue&type=style&index=0&id=2c55b214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55b214",
  null
  
)

export default component.exports